import { Table, Typography } from 'antd';
import React from 'react';
import { formatoMonedaGenerico } from '../utils/converters';

const { Title } = Typography;

const DescripcionPlan = ({ plan }) => {
  if (!plan) {
    return null;
  }
  const columns = [
    {
      title: 'Detalle de Cobertura',
      dataIndex: 'detalle',
      key: 'detalle',
      render: (item, record) => {
        if (record.full) {
          return <strong>{item}</strong>;
        }
        return item;
      }
    },
    {
      title: plan ? plan[0].suma : 'Sumas',
      dataIndex: 'suma',
      key: 'suma',
      align: 'right',
      render: (item, record) => {
        return record.full ? (
          ''
        ) : (
          <strong style={{ whiteSpace: 'nowrap' }}>
            {Number.isNaN(Number(item))
              ? item
              : formatoMonedaGenerico(plan[0].moneda, item)}
          </strong>
        );
      }
    }
  ];

  const data = plan
    ? plan
        .slice(1, plan.length)
        .filter((item) => item.detalle && item.detalle.trim())
        .map((item) => ({
          ...item,
          key: item.detalle
        }))
    : [];

  return (
    <>
      <br />
      <Title level={5} style={{ textAlign: 'left' }}>
        Plan seleccionado
      </Title>
      <div style={{ display: 'flex' }}>
        <Table
          size="small"
          fixed
          scroll={false}
          style={{ overflowX: 'auto' }}
          bordered
          dataSource={data}
          columns={columns}
          pagination={false}
        />
      </div>
    </>
  );
};

export default DescripcionPlan;
